import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {
  Aangifte,
  BokkzAlgDataService,
  IncomeTaxEntity,
  Voorheffingen
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BehaviorSubject, filter, Subscription} from "rxjs";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder} from "@angular/forms";
import {Event, NavigationEnd, Router} from "@angular/router";
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-voorlopige-aanslagen',
  templateUrl: './voorlopige-aanslagen.component.html',
  styleUrls: ['./voorlopige-aanslagen.component.scss'],
  imports: [
    SharedUiDetailsModule,
    SharedUiFormControlsModule
  ]
})
export class VoorlopigeAanslagenComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isSaving = false;
    public clientId!: string;

    @Input() public id!: string;
    public aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    public partnerBoolean = {} as boolean;
    @Input() partner = new BehaviorSubject<boolean>(false);
    private partnerAangifte = {} as Aangifte

    public isDefAangifte = {} as boolean;

    public voorlAanslag = this.fb.group<Voorheffingen>({})
    public voorlTeruggaaf = this.fb.group<Voorheffingen>({})
    public voorlZvw = this.fb.group<Voorheffingen>({});

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private router: Router, private fb: FormBuilder) {
        this.voorlAanslag = this.fb.group<Voorheffingen>({
            voorlopigeAanslag: null as unknown as number,
        });
        this.voorlTeruggaaf = this.fb.group<Voorheffingen>({
            voorlopigeAanslag: null as unknown as number,
        });
        this.voorlZvw = this.fb.group<Voorheffingen>({
            voorlopigeAanslagZvw: null as unknown as number,
        });
    }
    private resetVA() {
        this.voorlAanslag.setValue({voorlopigeAanslag: null as unknown as number,}, {emitEvent: false});
    }

    private resetVATerug() {
        this.voorlTeruggaaf.setValue({voorlopigeAanslag: null as unknown as number,}, {emitEvent: false});
    }

    private resetVAZvw() {
        this.voorlZvw.setValue({voorlopigeAanslagZvw: null as unknown as number,}, {emitEvent: false});
    }

    public ngOnInit(): void {
        this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte;
                this.aangifte = aangifte;
                this.partnerAangifte = aangifte.partnerAangifte ? aangifte.partnerAangifte : {} as Aangifte;
                this.updateForm();
                this.partner.subscribe((partner) => {
                        this.partnerBoolean = partner
                        this.resetVA()
                        this.resetVATerug()
                        this.resetVAZvw()
                        this.updateForm();
                });
            }
        });
        this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
        });
        this.routerSubscription = this.router.events
            .pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                this.handleUrlChange(event.urlAfterRedirects);
            });
    }

    ngOnDestroy(): void {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
        }
        if (this.incomeTaxEntitySubscription) {
            this.incomeTaxEntitySubscription.unsubscribe(); // Unsubscribe from income tax entity
        }
        if (this.clientEntitySubscription) {
            this.clientEntitySubscription.unsubscribe();
        }
    }

    handleUrlChange(newUrl: string) {
        if (!this.isSaving && this.hasUnsavedChanges()) {
            this.isSaving = true;
            this.dataService.postIncomeTaxEntity(this.clientId, false, this.incomeTaxEntity);
            this.isSaving = false;
        }
    }

    private hasUnsavedChanges(): boolean {
        return this.voorlAanslag.dirty || this.voorlZvw.dirty || this.voorlTeruggaaf.dirty
    }

    private updateForm() {
                if (!this.partnerBoolean) {
                    if (this.aangifte && this.aangifte.voorheffingen && this.aangifte.voorheffingen.voorlopigeAanslag) {
                        const waarde = this.aangifte.voorheffingen.voorlopigeAanslag;
                        if (waarde < 0) {
                            this.voorlTeruggaaf.patchValue({voorlopigeAanslag: waarde * -1,});
                        } else if (waarde >= 0) {
                            this.voorlAanslag.patchValue({voorlopigeAanslag: waarde});
                        }
                    }
                    this.voorlZvw.patchValue({
                        voorlopigeAanslagZvw: this.aangifte?.voorheffingen?.voorlopigeAanslagZvw || null,
                    });
                } else {
                    if (this.aangifte && this.aangifte.partnerAangifte && this.aangifte.partnerAangifte.voorheffingen && this.aangifte.partnerAangifte.voorheffingen.voorlopigeAanslag) {
                        const waarde = this.aangifte.partnerAangifte.voorheffingen.voorlopigeAanslag;
                        if (waarde < 0) {
                            this.voorlTeruggaaf.patchValue({voorlopigeAanslag: waarde * -1,});
                        } else {
                            this.voorlAanslag.patchValue({voorlopigeAanslag: waarde,});
                        }
                    }
                    this.voorlZvw.patchValue({
                        voorlopigeAanslagZvw: this.aangifte?.partnerAangifte?.voorheffingen?.voorlopigeAanslagZvw || null,
                    });
                }
    }

    saveForm(): void {
        if (!this.partnerBoolean) {
            let waarde = 0;
            if (this.voorlTeruggaaf && this.voorlTeruggaaf.value && this.voorlTeruggaaf.value.voorlopigeAanslag && this.voorlTeruggaaf.value.voorlopigeAanslag > 0) {
                waarde = (this.voorlTeruggaaf?.value.voorlopigeAanslag ? this.voorlTeruggaaf?.value?.voorlopigeAanslag * -1 : null as unknown as number)
            }
            if (this.voorlAanslag && this.voorlAanslag.value && this.voorlAanslag.value.voorlopigeAanslag && this.voorlAanslag.value.voorlopigeAanslag > 0) {
                waarde = (this.voorlAanslag?.value.voorlopigeAanslag ? this.voorlAanslag?.value?.voorlopigeAanslag : null as unknown as number)
            }
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                voorheffingen: {
                    ...this.aangifte.voorheffingen,
                    voorlopigeAanslag: waarde !== 0 ? waarde : null as unknown as number,
                    voorlopigeAanslagZvw: this.voorlZvw.value.voorlopigeAanslagZvw,
                }
            } as Aangifte;

            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
        } else {
            let waarde = 0;
            if (this.voorlTeruggaaf && this.voorlTeruggaaf.value && this.voorlTeruggaaf.value.voorlopigeAanslag && this.voorlTeruggaaf.value.voorlopigeAanslag > 0) {
                waarde = (this.voorlTeruggaaf?.value.voorlopigeAanslag ? this.voorlTeruggaaf?.value?.voorlopigeAanslag * -1 : null as unknown as number)
            }
            if (this.voorlAanslag && this.voorlAanslag.value && this.voorlAanslag.value.voorlopigeAanslag && this.voorlAanslag.value.voorlopigeAanslag > 0) {
                waarde = (this.voorlAanslag?.value.voorlopigeAanslag ? this.voorlAanslag?.value?.voorlopigeAanslag : null as unknown as number)
            }
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                partnerAangifte: {
                    ...this.aangifte.partnerAangifte,
                    voorheffingen: {
                        ...this.aangifte.voorheffingen,
                        voorlopigeAanslag: waarde !== 0 ? waarde : null as unknown as number,
                        voorlopigeAanslagZvw: this.voorlZvw.value.voorlopigeAanslagZvw,
                    }
                },
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
        }

    }
}
